import { DashboardDataCard } from '@ygtechnologies/bygr-frontend-component-library';
import React from 'react';
import theme from './PrimaryCard.module.scss';

interface DataRowProps {
    label: string;
}
export const DataRow: React.FC<DataRowProps> = ({ label, children }) => {
    return (
        <>
            <small>{label}</small>
            <span>{children}</span>
        </>
    );
};

interface PrimaryCardProps {
    loading?: boolean;
    title?: string;
    className?: string;
}

const PrimaryCard: React.FC<PrimaryCardProps> = ({ loading, children, title, className }) => {
    return (
        <DashboardDataCard className={className} title={title} contentClassName={theme.card} loading={loading}>
            {children}
        </DashboardDataCard>
    );
};

export default PrimaryCard;
